import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AccionesDialog, TiposMovimiento } from '@models/base/identificadores.model';
import { DialogCreateMovimientoComponent } from '@views/movimientos/dialog-create-movimiento/dialog-create-movimiento.component';
import { DialogNuevoMovimientoCajaComponent } from '@views/caja/dialog-nuevo-movimiento-caja/dialog-nuevo-movimiento-caja.component';

/**
 * Accesos rápidos de la barra superior.
 *
 * Junta en un solo lugar los cuatro "nuevo" que hoy obligan a navegar hasta el
 * listado correspondiente para recién ahí encontrar el botón.
 *
 * Cada opción respeta el permiso del alta que dispara: si el usuario no puede
 * crear contratos, no ve la opción. Si no puede crear ninguna de las cuatro
 * cosas, no se dibuja ni el botón.
 */
@Component({
  selector: 'app-btn-accesos-rapidos',
  templateUrl: './btn-accesos-rapidos.component.html',
  styleUrls: ['./btn-accesos-rapidos.component.css']
})
export class BtnAccesosRapidosComponent {

  /** Gira el "+" mientras el menú está abierto */
  menuAbierto = false

  constructor(public dialog: MatDialog) { }

  /**
   * Movimiento y Movimiento de Propiedad son el mismo diálogo: cambia si pide
   * contrato o propiedad. Se abre sin contrato porque desde la barra superior no
   * hay ninguno en contexto; el propio formulario lo pide.
   */
  abrirNuevoMovimiento(esMovimientoPropiedad: boolean) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.autoFocus = false;
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = '95%';
    dialogConfig.data = {
      contratoDetailDto: undefined,
      tiposMovimiento: [],
      // Los de caja tienen su propio alta, con la caja y la forma de pago
      tiposMovimientoExluidos: [TiposMovimiento.IngresoCaja, TiposMovimiento.EgresoCaja],
      esMovimientoPropiedad: esMovimientoPropiedad
    };

    this.dialog.open(DialogCreateMovimientoComponent, dialogConfig);
  }

  abrirNuevoMovimientoCaja() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '100%';
    dialogConfig.maxWidth = '95%';
    dialogConfig.data = { event: AccionesDialog.Agregar };
    dialogConfig.autoFocus = false;
    dialogConfig.disableClose = true;

    this.dialog.open(DialogNuevoMovimientoCajaComponent, dialogConfig);
  }
}
